export default function fileUrl(path: string): string {
  return `${process.env.VUE_APP_FILE_SERVER_URL}/${path}`;
}
